import { render, staticRenderFns } from "./InformasiVM.vue?vue&type=template&id=5ef328ba&"
import script from "./InformasiVM.vue?vue&type=script&lang=js&"
export * from "./InformasiVM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports